import { useTranslation } from 'react-i18next'
import { Divider, ExpandableListItem, List, ListItem, usePageWidth, Ellipsis } from '@fs/zion-ui'
import React, { useCallback } from 'react'
import { i18n } from '@fs/zion-locale'
import getFormattedDate, { dateFormats } from '../../../../../shared/utils/dateFormatHelper'
import styles from './CoverageList.styles'

export default function CoverageList({ coverages }) {
  const [t] = useTranslation()
  const pageWidth = usePageWidth()
  const isMobile = pageWidth({ default: true, lg: false })
  const memoizedGetDates = useCallback((recordTypeDates) => {
    return getDates(recordTypeDates)
  }, [])

  // eslint-disable-next-line react/no-unstable-nested-components
  const RecordType = ({ key, name = '', dates = '' }) => (
    <ListItem
      key={key}
      dense
      primaryText=""
      secondaryText={
        <div css={styles.recordType(isMobile)}>{name || t('RecordType.noRecordType', 'No Record Type')}</div>
      }
      endElement={
        <ListItem.MetaText
          // see comments in CoverageList.styles.js
          text={
            dates ? (
              <Ellipsis lineClamp={2}>
                <span data-date-list>{dates}</span>
              </Ellipsis>
            ) : (
              t('RecordType.noDate', 'No Date')
            )
          }
        />
      }
    />
  )

  return (
    <div css={styles.list(isMobile)}>
      <List>
        {coverages?.map(({ place, recordTypes }) => (
          <ExpandableListItem key={place?.id} dense primaryText={place?.fullName} initiallyOpen>
            {recordTypes?.map((rt) => (
              <RecordType key={`${place?.id}-${rt.id}`} name={rt.name} dates={memoizedGetDates(rt.date)} />
            ))}
          </ExpandableListItem>
        ))}
      </List>
      <Divider />
    </div>
  )
}

function getDates(dates = []) {
  const yearRanges = dates.reduce(
    (accu, date) =>
      Number.isInteger(date?.fromTimestamp)
        ? [...accu, getFormattedDate(date.fromTimestamp, date.toTimestamp, dateFormats.formatted)]
        : accu,
    []
  )
  return new Intl.ListFormat(i18n.language, { style: 'narrow', type: 'conjunction' }).format(yearRanges)
}
